export default __webpack_public_path__ + "static/media/NIAS0260.34I-31035_-17663_0.9fcf89f4.jpg";